import SearchComponent from '../SearchComponent/SearchComponent.vue'
import '../../mixins.js'

export default {
  name: 'header',
  components: {
    searchcomponent: SearchComponent,
  },
  props: [],
  data () {
    return {

    }
  },
  computed: {
  },
  mounted () {
    this.buttonActivation('nav-bar-header','btnHeader');
    var acc = document.getElementsByClassName("dropbtn");
    var i;

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {
        this.classList.toggle("active");
        
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
          document.getElementById("dropdown-content-mobile").style.overflow = 'hidden'
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
          setTimeout(() => document.getElementById("dropdown-content-mobile").style.overflow = 'visible', 200)
          
        }
      });
    }
  },
  methods: {
saveLogout: function(){
  localStorage.removeItem("access-token");
  localStorage.removeItem("refresh-token");
  this.$router.push("/logout");
}
  },
}


